import { render, staticRenderFns } from "./JapaneseWork.vue?vue&type=template&id=e31289a8&scoped=true&"
import script from "./JapaneseWork.ts?vue&type=script&lang=ts&"
export * from "./JapaneseWork.ts?vue&type=script&lang=ts&"
import style0 from "./JapaneseWork.css?vue&type=style&index=0&id=e31289a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31289a8",
  null
  
)

export default component.exports